import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

/**
 * Short-URL redirect: /r/:code → /?ref=:code
 * Logs the click to referral_clicks for conversion analytics.
 */
const ReferralRedirect = () => {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const track = async () => {
      if (!code) {
        navigate("/", { replace: true });
        return;
      }

      // Deduplicate: only log once per referral code per browser session
      const dedupKey = `elara_ref_click_${code}`;
      if (!sessionStorage.getItem(dedupKey)) {
        sessionStorage.setItem(dedupKey, "1");

        const url = new URL(window.location.href);

        const { error } = await supabase.from("referral_clicks").insert({
          referral_code: code,
          user_agent: navigator.userAgent,
          referrer: document.referrer || null,
          landing_page: window.location.href,
          ip_hint: null,
          utm_source: url.searchParams.get("utm_source") || null,
          utm_medium: url.searchParams.get("utm_medium") || null,
          utm_campaign: url.searchParams.get("utm_campaign") || null,
          utm_content: url.searchParams.get("utm_content") || null,
          utm_term: url.searchParams.get("utm_term") || null,
        });

        if (error) {
          console.warn("Referral click tracking failed:", error.message);
        } else {
          console.info(`[analytics] referral click tracked: code=${code}`);
        }
      }

      navigate(`/?ref=${encodeURIComponent(code)}`, { replace: true });
    };

    track();
  }, [code, navigate]);

  return null;
};

export default ReferralRedirect;
